import { getIrr, getIrrConclusion } from "./IrrCard.helpers";

import IrrCard from "./IrrCard";

const IrrCardContainer = ({
  conclusionsPro,
  userScenarioResult,
  activePosition,
}: {
  conclusionsPro: any;
  userScenarioResult: string;
  activePosition: 10 | 20 | 30;
}) => {
  const irr = getIrr({
    conclusionsPro,
    userScenarioResult,
    activePosition,
  });

  const irrConclusion = getIrrConclusion(irr);

  return <IrrCard irrConclusion={irrConclusion} irr={irr} />;
};

export default IrrCardContainer;
